import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "左滑",
  "use": "左滑-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"左滑\"><path d=\"M272.896 457.728L677.76 52.224A76.8 76.8 0 0 1 808.96 106.496v811.008a76.8 76.8 0 0 1-131.2 54.272L272.896 566.272a76.8 76.8 0 0 1 0-108.544z\" p-id=\"1410\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol